export default Object.freeze({
  COMPLETED: 'Complete',
  ON_TRACK: 'On track',
  OFF_TRACK: 'Off track',
  INCOMPLETE: 'Incomplete'
})
